import { RouteConfig } from 'vue-router';
const List = () => import('./views/list.vue');
const routers: RouteConfig[] = [
    {
        path: 'list',
        component: List,
    },
];
export default routers;
